{
    "ai_modal_title_1": "Покращити текст за допомогою ШІ",
    "ai_modal_title_2": "Створити текст за допомогою ШІ",
    "ai_description": "Використовуйте інструменти ШІ, щоб покращити ваші тексти.",
    "ai_learn_more": "Дізнатися більше",
    "ai_copy_text": "Копіювати текст",
    "ai_describe_your_text": "Опишіть про що має бути ваш текст",
    "ai_describe_your_text_example": "Наприклад, невеликий опис для магазину крафтового мила...",
    "ai_new_request": "Створити новий запит",
    "ai_create_text": "Створити текст",
    "ai_apply_text": "Застосувати текст",
    "ai_try_one_more": "Спробувати ще раз",
    "ai_correct_errors": "Виправити помилки",
    "ai_make_longer": "Зробити довшим",
    "ai_make_shorter": "Скоротити",
    "ai_simplify": "Спростити",
    "ai_business_tone": "Діловий",
    "ai_ceremonial_tone": "Урочистий",
    "ai_fun_tone": "Веселий",
    "ai_friendly_tone": "Дружній",
    "ai_change_tone": "Змінити тон",
    "ai_improve_text": "Покращити текст",
    "ai_words_number": "Кількість слів:",
    "ai_translate": "Перекласти",
    "ai_translate_to_ru": "Перекласти російською",
    "ai_translate_to_en": "Перекласти англійською",
    "ai_add_creativity": "Додати креативу",
    "ai_text_too_large": "Ваш текст задовгий для використання ШІ. Скоротіть його або створіть новий текст потрібної тематики за допомогою ШІ.",
    "ai_translate_to_ua": "Перекласти українською",
    "ai_translate_to_es": "Перекласти іспанською",
    "ai_translate_to_pt": "Перекласти португальською",
    "ai_translate_to_tr": "Перекласти турецькою",
    "ai_translate_to_fr": "Перекласти французькою",
    "ai_translate_to_de": "Перекласти німецькою",
    "ai_translate_to_it": "Перекласти італійською",
    "ai_translate_to_pl": "Перекласти польською",
    "ai_free_request_error": "Безкоштовні запити закінчились",
    "ai_free_request_number": "Кількість запитів: {{ FREE_KEY }} / {{ FREE_KEY_LIMIT }}",
    "ai_request_limit_info": "Ви можете використовувати 200 безплатних запитів до інструментів ШІ. Щоб створити більше запитів, активуйте свій API-ключ сервісу ШІ у налаштуваннях вашого акаунту.",
    "cancel": "Скасувати",
    "gpt_error_quota": "Ви вичерпали доступну кількість запитів API. Щоб використовувати інструменти ШІ надалі, перевірте поточний ліміт або поповніть баланс у налаштуваннях облікового запису OpenAI.",
    "ai_generated_disclaimer": "Відповідальність за згенерований текст несете ви. Перевірте його перед публікацією."
}
